import { render, staticRenderFns } from "./BlockType8.vue?vue&type=template&id=e523ecd4&scoped=true"
import script from "./BlockType8.vue?vue&type=script&lang=ts"
export * from "./BlockType8.vue?vue&type=script&lang=ts"
import style0 from "./BlockType8.vue?vue&type=style&index=0&id=e523ecd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e523ecd4",
  null
  
)

export default component.exports